import React, { useState } from 'react'
import SingleColor from './SingleColor'
import ColorPalletForm from './components/ColorPalletForm/ColorPalletForm'
import Values from 'values.js'

import './css/App/App.css'

function App() {
  return (
    <div className='app-level'>
    
    <ColorPalletForm />
    
    </div>

  );



}

export default App
